import FavoritePage from "./favorite-page";
import FavoriteSubPage from "./sub-page";

const Favorite = {
    Page : FavoritePage,
    SubPage : FavoriteSubPage
};

export default Favorite;